export const prismicConfig = {
    endpoint: 'https://astro-otter.prismic.io/api/v2'
}